var map = {
	"./af/language.json": 26358,
	"./ak/language.json": 80018,
	"./am/language.json": 81975,
	"./ar/language.json": 30702,
	"./as/language.json": 8201,
	"./az/language.json": 85820,
	"./be/language.json": 7983,
	"./bg/language.json": 11687,
	"./bm/language.json": 71982,
	"./bn/language.json": 49957,
	"./bo/language.json": 41601,
	"./br/language.json": 68121,
	"./bs/language.json": 66341,
	"./ca/language.json": 34121,
	"./cs/language.json": 75567,
	"./cy/language.json": 56239,
	"./da/language.json": 74010,
	"./de/language.json": 33164,
	"./dz/language.json": 22409,
	"./ee/language.json": 68759,
	"./el/language.json": 55561,
	"./en/language.json": 87122,
	"./eo/language.json": 18596,
	"./es/language.json": 39243,
	"./et/language.json": 88955,
	"./eu/language.json": 30731,
	"./fa/language.json": 93995,
	"./ff/language.json": 2444,
	"./fi/language.json": 48937,
	"./fo/language.json": 1193,
	"./fr/language.json": 56225,
	"./fy/language.json": 9207,
	"./ga/language.json": 81567,
	"./gd/language.json": 83733,
	"./gl/language.json": 83944,
	"./gu/language.json": 72068,
	"./gv/language.json": 64307,
	"./ha/language.json": 89604,
	"./he/language.json": 11476,
	"./hi/language.json": 41183,
	"./hr/language.json": 58639,
	"./hu/language.json": 40998,
	"./hy/language.json": 37369,
	"./id/language.json": 98993,
	"./ig/language.json": 72490,
	"./ii/language.json": 58773,
	"./is/language.json": 17538,
	"./it/language.json": 69005,
	"./ja/language.json": 2217,
	"./ka/language.json": 87978,
	"./ki/language.json": 68372,
	"./kk/language.json": 31834,
	"./kl/language.json": 83760,
	"./km/language.json": 73779,
	"./kn/language.json": 21112,
	"./ko/language.json": 86864,
	"./ks/language.json": 9739,
	"./kw/language.json": 13177,
	"./ky/language.json": 97970,
	"./lb/language.json": 81943,
	"./lg/language.json": 33410,
	"./ln/language.json": 72072,
	"./lo/language.json": 59103,
	"./lt/language.json": 68487,
	"./lu/language.json": 58952,
	"./lv/language.json": 80609,
	"./mg/language.json": 8439,
	"./mk/language.json": 81078,
	"./ml/language.json": 83942,
	"./mn/language.json": 859,
	"./mr/language.json": 29802,
	"./ms/language.json": 19546,
	"./mt/language.json": 3358,
	"./my/language.json": 6558,
	"./nb/language.json": 40068,
	"./nd/language.json": 26686,
	"./ne/language.json": 30533,
	"./nl/language.json": 49091,
	"./nn/language.json": 1099,
	"./no/language.json": 11067,
	"./om/language.json": 27248,
	"./or/language.json": 6400,
	"./os/language.json": 65305,
	"./pa/language.json": 81673,
	"./pl/language.json": 2026,
	"./ps/language.json": 15431,
	"./pt/language.json": 57184,
	"./qu/language.json": 25078,
	"./rm/language.json": 69076,
	"./rn/language.json": 58001,
	"./ro/language.json": 65117,
	"./ru/language.json": 11102,
	"./rw/language.json": 97746,
	"./se/language.json": 97758,
	"./sg/language.json": 612,
	"./sh/language.json": 96486,
	"./si/language.json": 52947,
	"./sk/language.json": 27362,
	"./sl/language.json": 8302,
	"./sn/language.json": 64801,
	"./so/language.json": 18665,
	"./sq/language.json": 31142,
	"./sr/language.json": 57070,
	"./sv/language.json": 85580,
	"./sw/language.json": 84971,
	"./ta/language.json": 21365,
	"./te/language.json": 43123,
	"./th/language.json": 49631,
	"./ti/language.json": 22525,
	"./tl/language.json": 93151,
	"./to/language.json": 96445,
	"./tr/language.json": 31601,
	"./ug/language.json": 54641,
	"./uk/language.json": 20554,
	"./ur/language.json": 42850,
	"./uz/language.json": 66448,
	"./vi/language.json": 18908,
	"./yi/language.json": 70259,
	"./yo/language.json": 4819,
	"./zh/language.json": 35613,
	"./zu/language.json": 23931
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85217;